import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { path, contains } from 'ramda';

import { isNilOrEmpty } from '../../../util/redux';
import magic from '../../../util/magic';
import { getRegistrationExpirationInfo } from '../../../util/helpers';

import Announcements from '../../../components/Announcements';
import CertificationsCard from './components/CertificationsCard';
import RegistrationCard from './components/RegistrationCard';
import EngagementCard from './components/EngagementCard';
import CertificationResources from './components/CertificationResources';

const mapState = ({ announcements, user, certificationResources }) => ({
  announcements,
  certificationResources,
  user,
});

const propTypes = {
  announcements: PropTypes.array,
  certificationResources: PropTypes.array,
  user: PropTypes.object,
};

const Dashboard = ({ announcements, certificationResources, user }) => {
  const registrations = user.latestRegistrations.filter((r) => r.status != magic.complete);
  const isMember = path(['membership', 'valid'], user);
  const nonExpiredCertRegistrations = registrations.filter((r) => {
    getRegistrationExpirationInfo(r, user.extensions);
    return (
      path(['expirationStatus'], r) == magic.notExpired &&
      !contains(r.status, magic.preRegistrationStatuses) &&
      path(['certificationId'], r) != null
    );
  });
  return (
    <div className="row">
      <div className="col">
        <Announcements
          className="mb-4"
          announcements={announcements.filter((a) => (isMember ? true : a.type != magic.membershipAnnouncement))}
        />
        {!isNilOrEmpty(nonExpiredCertRegistrations) && (
          <CertificationResources resources={certificationResources} registrations={nonExpiredCertRegistrations} />
        )}
        {!isNilOrEmpty(user.userCertifications) && (
          <CertificationsCard certifications={user.userCertifications} renewal={user.renewal} />
        )}
        {registrations.map((registration) => (
          <RegistrationCard key={registration.id} registration={registration} extensions={user.extensions} />
        ))}
      </div>
    </div>
  );
};

Dashboard.propTypes = propTypes;

export default connect(mapState)(Dashboard);
